<template>
	<string-view class="number-view" v-bind="$attrs" v-model="formatted" />
</template>

<script>
	export default {
		watch: {
			formatted(n) {
				// Calculate and update value
				const val = this.$options.filters.unwrapDecimal(n);

				console.log('formatted', n, val, this.value);

				if (val != this.value) {
					console.log('UPDATE');
					this.$emit('input', val);
				}
			},
			value: {
				handler(n) {
					// Calculate and update formatted
					const val = this.$options.filters.wrapDecimal(n);

					console.log('value', n, val, this.formatted);

					if (val != this.formatted) {
						console.log('UPDATE');
						this.formatted = val;
					}
				},
				immediate: true
			}
		},
		data() {
			return {
				formatted: ''
			};
		},
		props: {
			value: {
				type: String,
				default: ''
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>